import { Injectable } from '@angular/core'; import * as ExcelJS from 'exceljs';

@Injectable()
export class FarReportUtilService {

    private numberFormat = "#,##0.00";
    private fontStyle = {
        header: { name: 'Times New Roman', size: 10, bold: true },
        content: { name: 'Times New Roman', size: 10 }
    };
    private columns = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R'];
    private borderStyle: any = {
        thin: { style: 'thin' },
        full: {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' }
        },
        topBottom: {
            top: { style: 'thin' },
            bottom: { style: 'thin' }
        },
        leftRight: {
            left: { style: 'thin' },
            right: { style: 'thin' }
        },
        topLeft: {
            top: { style: 'thin' },
            left: { style: 'thin' }
        },
        topRight: {
            top: { style: 'thin' },
            left: { style: 'thin' }
        },
        bottomLeft: {
            bottom: { style: 'thin' },
            left: { style: 'thin' }
        },
        bottomRight: {
            bottom: { style: 'thin' },
            right: { style: 'thin' }
        }
    };
    private rowStart: number = 11;

    constructor() { }

    async generateFar2AExcel(data: Array<any>, options: any = { fileName: "Far2A_Report", sheetName: "Far2A" }) {

        const wb = new ExcelJS.Workbook();
        wb.addWorksheet(options.sheetName);

        const ws = wb.getWorksheet(options.sheetName);

        ws.columns = [
            { header: "", key: "acct_title", width: 50 },
            { header: "", key: "acct_uacs_code", width: 15 },
            { header: "", key: "appr_amount", width: 15 },
            { header: "", key: "re_total", width: 15 },
            { header: "", key: "adj_bgt_rev", width: 15 },
            { header: "", key: "ors_q1", width: 15 },
            { header: "", key: "ors_q2", width: 15 },
            { header: "", key: "ors_q3", width: 15 },
            { header: "", key: "ors_q4", width: 15 },
            { header: "", key: "ors_total", width: 15 },
            { header: "", key: "dis_q1", width: 15 },
            { header: "", key: "dis_q2", width: 15 },
            { header: "", key: "dis_q3", width: 15 },
            { header: "", key: "dis_q4", width: 15 },
            { header: "", key: "dis_total", width: 15 },
            { header: "", key: "unutilized_bgt", width: 15 },
            { header: "", key: "due_demmandable", width: 15 },
            { header: "", key: "not_yet_due", width: 15 }
        ];

        // format ors report content
        let content = [];
        let stringValProperty = ["acct_uacs_code", "acct_title", "aa_id", "aa_year", "campus_branch_code"];
        JSON.parse(JSON.stringify(data)).forEach((d: any, indx: number) => {
            d.acct_uacs_code = ((uacs: string) => {
                console.log(`uacs ${uacs}`);
                if ((uacs.substring(0, 2) != "59") && (uacs.substring(0, 2) != "99") && (uacs.substring(0, 3) != "500")) {
                    return uacs;
                }
                if (uacs.substring(0, 3) == "590") {
                    return " ";
                }
                return (uacs.substring(0, 2) == "59") ? "  " : " ";
            })(d.acct_uacs_code);
            Object.keys(d).forEach((key: any) => {
                if (!stringValProperty.includes(key)) {
                    d[key] = (Number(d[key]) != 0) ? Number(d[key]) : null;

                    let currentRow = (this.rowStart + 5) + indx;

                    let adj_bgt_rev = Number(d.appr_amount) + Number(d.re_total);
                    d['adj_bgt_rev'] = (adj_bgt_rev != 0) ? { formula: `=C${currentRow}+D${currentRow}`, date1904: false } : null;

                    let ors_total = Number(d.ors_q1) + Number(d.ors_q2) + Number(d.ors_q3) + Number(d.ors_q4);
                    d['ors_total'] = (ors_total != 0) ? { formula: `=F${currentRow}+G${currentRow}+H${currentRow}+I${currentRow}`, date1904: false } : null;

                    let dis_total = Number(d.dis_q1) + Number(d.dis_q2) + Number(d.dis_q3) + Number(d.dis_q4);
                    d['dis_total'] = (dis_total != 0) ? { formula: `=K${currentRow}+L${currentRow}+M${currentRow}+N${currentRow}`, date1904: false } : null;

                    let unutilized_bgt = adj_bgt_rev - dis_total;
                    d['unutilized_bgt'] = (unutilized_bgt != 0) ? { formula: `=E${currentRow}-J${currentRow}`, date1904: false } : null;

                    let due_demmandable = Number(d.ospp_payable) - Number(dis_total);
                    d['due_demmandable'] = (due_demmandable != 0) ? due_demmandable : null;

                    let not_yet_due = Number(ors_total) - Number(d.ospp_payable);
                    d['not_yet_due'] = (not_yet_due != 0) ? not_yet_due : null;

                }
            });
            content.push(d);
        });
        console.log(`generateFar2AExcel()->content`, content);

        this.setHeader(ws);
        content.forEach((data: any) => {
            ws.addRow(data);
        });
        this.setDefaultPageStyles(ws, content, '2a');

        const arrayData = await wb.xlsx.writeBuffer();
        const blob = new Blob([arrayData], { type: "application/octet-binary" });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `${options.fileName}.xlsx`;
        a.click();
        a.remove();
    }

    async generateFar2Excel(data: Array<any>, options: any = { fileName: "Far2_Report", sheetName: "Far2" }) {

        const wb = new ExcelJS.Workbook();
        wb.addWorksheet(options.sheetName);

        const ws = wb.getWorksheet(options.sheetName);

        ws.columns = [
            { header: "", key: "particulars", width: 37 },
            { header: "", key: "uacs_code", width: 20 },
            { header: "", key: "appr_amount", width: 17 },
            { header: "", key: "re_total", width: 17 },
            { header: "", key: "adj_bgt_rev", width: 17 },
            { header: "", key: "ors_q1", width: 17 },
            { header: "", key: "ors_q2", width: 17 },
            { header: "", key: "ors_q3", width: 17 },
            { header: "", key: "ors_q4", width: 17 },
            { header: "", key: "ors_total", width: 17 },
            { header: "", key: "dis_q1", width: 17 },
            { header: "", key: "dis_q2", width: 17 },
            { header: "", key: "dis_q3", width: 17 },
            { header: "", key: "dis_q4", width: 17 },
            { header: "", key: "ospp_payment", width: 17 },
            { header: "", key: "unutilized_bgt", width: 17 },
            { header: "", key: "due_demmandable", width: 17 },
            { header: "", key: "not_yet_due", width: 17 }
        ];

        // format ors report content
        let content = [];
        let stringValProperty = ["exp_class", "particulars", "uacs_code"];
        JSON.parse(JSON.stringify(data)).forEach((d: any, indx: number) => {
            Object.keys(d).forEach((key: any) => {
                if (key == "uacs_code") {
                    d[key] = (d[key] != null && d[key].length > 10) ? d[key] : "";
                }
                if (!stringValProperty.includes(key)) {
                    d[key] = (Number(d[key]) != 0) ? Number(d[key]) : null;

                    let currentRow = (this.rowStart + 5) + indx;

                    let adj_bgt_rev = Number(d.appr_amount) + Number(d.re_total);
                    d['adj_bgt_rev'] = (adj_bgt_rev != 0) ? { formula: `=C${currentRow}+D${currentRow}`, date1904: false } : null;

                    let ors_total = Number(d.ors_q1) + Number(d.ors_q2) + Number(d.ors_q3) + Number(d.ors_q4);
                    d['ors_total'] = (ors_total != 0) ? { formula: `=F${currentRow}+G${currentRow}+H${currentRow}+I${currentRow}`, date1904: false } : null;

                    let ospp_payment = Number(d.dis_q1) + Number(d.dis_q2) + Number(d.dis_q3) + Number(d.dis_q4);
                    d['ospp_payment'] = (ospp_payment != 0) ? { formula: `=K${currentRow}+L${currentRow}+M${currentRow}+N${currentRow}`, date1904: false } : null;

                    let unutilized_bgt = adj_bgt_rev - ospp_payment;
                    d['unutilized_bgt'] = (unutilized_bgt != 0) ? { formula: `=E${currentRow}-O${currentRow}`, date1904: false } : null;

                    let due_demmandable = Number(d.ospp_payable) - Number(ospp_payment);
                    d['due_demmandable'] = (due_demmandable != 0) ? due_demmandable : null;

                    let not_yet_due = Number(ors_total) - Number(d.ospp_payable);
                    d['not_yet_due'] = (not_yet_due != 0) ? not_yet_due : null;

                }
            });
            content.push(d);
        });
        console.log(`generateFar2Excel()->content`, content);

        this.setHeader(ws);
        content.forEach((data: any) => {
            ws.addRow(data);
        });
        this.setDefaultPageStyles(ws, content, '2');

        const arrayData = await wb.xlsx.writeBuffer();
        const blob = new Blob([arrayData], { type: "application/octet-binary" });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `${options.fileName}.xlsx`;
        a.click();
        a.remove();
    }

    private setDefaultPageStyles(ws: ExcelJS.Worksheet, data: Array<any>, type: string = '2') {
        let len = data.length;
        let row = 11;
        let dataIndex = 0;
        for (let i = 0; i < (len + 5); i++) {
            this.columns.forEach((c: any) => {
                let currentRow = row + i;
                let cell = ws.getCell(`${c}${currentRow}`);
                cell.font = this.fontStyle.header;
                cell.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

                // content
                if (currentRow > (row + 4)) {
                    dataIndex = currentRow - (row + 5);
                    cell.style = { numFmt: this.numberFormat };

                    cell.font = this.fontStyle.content;
                    if (type == '2') {
                        // set header
                        if (data[dataIndex].uacs_code?.length > 10 || (data[dataIndex].exp_class == null)) {
                            cell.font = this.fontStyle.header;
                        }
                    }
                    if (type == '2a') {
                        // set header
                        if (((data[dataIndex].aa_id == null && data[dataIndex].acct_uacs_code.substring(0, 2) != "59") || data[dataIndex].aa_id == "") && (data[dataIndex].acct_uacs_code != "  ")) {
                            cell.font = this.fontStyle.header;
                        }
                    }

                    cell.alignment = { wrapText: true, vertical: 'middle', horizontal: 'right' };

                    // set particulars indentation
                    if (c == 'A') {
                        if (type == '2') {
                            cell.alignment = {
                                wrapText: true,
                                vertical: 'middle',
                                horizontal: 'left',
                                indent: ((data: any) => {

                                    if (data.exp_class == null) {
                                        // for grand total
                                        return;
                                    }

                                    if (data.uacs_code?.length > 10) {
                                        if (data.uacs_code.substring(1) != "00000000000000") {
                                            return 1;
                                        }
                                        return;
                                    }
                                    if ((data.uacs_code == null) && (data.allotment_class_code == null)) {
                                        return 1;
                                    }
                                    if ((data.uacs_code != null) && (data.allotment_class_code == null)) {
                                        return 1;
                                    }
                                    return 2;
                                })(data[dataIndex])
                            };
                        }

                        if (type == '2a') {
                            cell.alignment = {
                                wrapText: true,
                                vertical: 'middle',
                                horizontal: 'left',
                                indent: ((data: any) => {
                                    let uacs = data.acct_uacs_code;
                                    if (uacs.substring(0, 2) == "59") {
                                        if (data.aa_id == "") {
                                            return 1;
                                        }
                                        return 2;
                                    }
                                    if (uacs.substring(3) == "0000000" || uacs == " ") {
                                        return 1;
                                    }
                                    if (uacs.substring(5) == "00000" || uacs == "  ") {
                                        return 2;
                                    }
                                    if (uacs.substring(7) == "000") {
                                        return 3;
                                    }
                                    if (uacs.substring(uacs.length - 2) != "00" && uacs.substring(0, 2) != "99") {
                                        return 4;
                                    }
                                    return 0;
                                })(data[dataIndex])
                            };
                        }
                    }

                    if (c == 'B') {
                        cell.alignment = { wrapText: true, vertical: 'middle', horizontal: 'center' };
                    }

                }

                cell.border = this.borderStyle.full;
            });
        }
    }

    private setHeader(ws: ExcelJS.Worksheet) {
        let row = 11;
        ws.mergeCells(`A${row}:A${row + 3}`);
        ws.getCell(`A${row}`).value = "Particulars";
        ws.getCell(`A${row + 4}`).value = "1";

        ws.mergeCells(`B${row}:B${row + 3}`);
        ws.getCell(`B${row}`).value = "UACS CODE";
        ws.getCell(`B${row + 4}`).value = "2";

        ws.mergeCells(`C${row}:E${row}`);
        ws.getCell(`C${row}`).value = "Approved Budget";

        ws.mergeCells(`C${(row + 1)}:C${(row + 1) + 2}`);
        ws.getCell(`C${row + 1}`).value = "Approved Budgeted Revenue";
        ws.getCell(`C${row + 4}`).value = "3";

        ws.mergeCells(`D${(row + 1)}:D${(row + 1) + 2}`);
        ws.getCell(`D${row + 1}`).value = "Adjustments (Additions, Reductions, Realignment)";
        ws.getCell(`D${row + 4}`).value = "4";

        ws.mergeCells(`E${(row + 1)}:E${(row + 1) + 2}`);
        ws.getCell(`E${row + 1}`).value = "Adjusted Budgeted Revenue";
        ws.getCell(`E${row + 4}`).value = "5=3+(-)4";

        ws.mergeCells(`F${row}:J${row}`);
        ws.getCell(`F${row}`).value = "Budget Utilization";

        ws.mergeCells(`F${row + 1}:F${row + 3}`);
        ws.getCell(`F${row + 1}`).value = "1st Quarter Ending March 31";
        ws.getCell(`F${row + 4}`).value = "6";

        ws.mergeCells(`G${row + 1}:G${row + 3}`);
        ws.getCell(`G${row + 1}`).value = "2nd Quarter Ending June 30";
        ws.getCell(`G${row + 4}`).value = "7";

        ws.mergeCells(`H${row + 1}:H${row + 3}`);
        ws.getCell(`H${row + 1}`).value = "3rd Quarter Ending Sept. 30";
        ws.getCell(`H${row + 4}`).value = "8";

        ws.mergeCells(`I${row + 1}:I${row + 3}`);
        ws.getCell(`I${row + 1}`).value = "4th Quarter Ending Dec. 31";
        ws.getCell(`I${row + 4}`).value = "9";

        ws.mergeCells(`J${row + 1}:J${row + 3}`);
        ws.getCell(`J${row + 1}`).value = "TOTAL";
        ws.getCell(`J${row + 4}`).value = "10=6+7+8+9";

        ws.mergeCells(`K${row}:O${row}`);
        ws.getCell(`K${row}`).value = "Disbursement";

        ws.mergeCells(`K${row + 1}:K${row + 3}`);
        ws.getCell(`K${row + 1}`).value = "1st Quarter Ending March 31";
        ws.getCell(`K${row + 4}`).value = "11";

        ws.mergeCells(`L${row + 1}:L${row + 3}`);
        ws.getCell(`L${row + 1}`).value = "2nd Quarter Ending June 30";
        ws.getCell(`L${row + 4}`).value = "12";

        ws.mergeCells(`M${row + 1}:M${row + 3}`);
        ws.getCell(`M${row + 1}`).value = "3rd Quarter Ending Sept. 30";
        ws.getCell(`M${row + 4}`).value = "13";

        ws.mergeCells(`N${row + 1}:N${row + 3}`);
        ws.getCell(`N${row + 1}`).value = "4th Quarter Ending 'Dec. 31";
        ws.getCell(`N${row + 4}`).value = "14";

        ws.mergeCells(`O${row + 1}:O${row + 3}`);
        ws.getCell(`O${row + 1}`).value = "TOTAL";
        ws.getCell(`O${row + 4}`).value = "15=11+12+13+14";

        ws.mergeCells(`P${row}:R${row}`);
        ws.getCell(`P${row}`).value = "Balances";

        ws.mergeCells(`P${row + 1}:P${row + 3}`);
        ws.getCell(`P${row + 1}`).value = "Unutilized Budget";
        ws.getCell(`P${row + 4}`).value = "16=5-10";

        ws.mergeCells(`Q${row + 1}:R${row + 1}`);
        ws.getCell(`Q${row + 1}`).value = "Unpaid Utilizations";

        ws.mergeCells(`Q${row + 2}:R${row + 2}`);
        ws.getCell(`Q${row + 2}`).value = "(10-15) = (17+18)";

        ws.getRow(row + 3).height = 56;

        ws.getCell(`Q${row + 3}`).value = "Due and Demandable/ Accounts Payable";
        ws.getCell(`Q${row + 4}`).value = "17";

        ws.getCell(`R${row + 3}`).value = "Not Yet Due and Demandable";
        ws.getCell(`R${row + 4}`).value = "18";


    }

}
